import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

export interface Page {
  number: number;
  isSelected: boolean;
}

@Component({
    selector: 'lib-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent implements OnInit {

  // how many next pages will be shown as numbers in pagination component before "..." will be used
  private readonly SHOW_PAGES_LIMIT = 2;

  @Output() newPageSelected = new EventEmitter<number>();

  @Input() currentPage: number = 1;
  @Input() pageSize: number = 20;
  @Input() pageCount: number = 0;
  @Input() totalCount: number = 0;
  @Input() showText: boolean = true;
  @Input() lightStyle: boolean = false;

  pages: Page[] = [];
  showLastPage = false;
  showEndDots = false;
  showFirstPage = false;
  showStartDots = false;

  ngOnInit() {
    this.#calculatePages(this.currentPage);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('pageSize' in changes || 'totalCount' in changes) {
      this.pageCount = Math.ceil(this.totalCount / this.pageSize);

      if (!changes['currentPage']){
        this.selectPage(1);
      }
    }
    this.#calculatePages(this.currentPage)
  }

  #calculatePages(selectedPage: number) {
    this.pages = [];

    //Add the first page
    if (this.pageCount > 0 && selectedPage > 1) {
      this.showFirstPage = true;
    } else {
      this.showFirstPage = false;
    }

    //Add previous pages
    for (let i = selectedPage - this.SHOW_PAGES_LIMIT; i < selectedPage; i++) {
      if (i > 1) {
        this.pages.push({ number: i, isSelected: false });
      }
    }

    //Add the current page
    this.pages.push({ number: selectedPage, isSelected: true });

    //Add next pages
    for (let i = selectedPage + 1; i <= selectedPage + this.SHOW_PAGES_LIMIT; i++) {
      if (i < this.pageCount) {
        this.pages.push({ number: i, isSelected: false });
      }
    }

    //Add the last page
    if (this.pageCount > 1 && selectedPage < this.pageCount) {
      this.showLastPage = true;
    } else {
      this.showLastPage = false;
    }

    //Check if the first displayed page has a gap before the first page.
    this.showStartDots = this.pages[0].number - 1 > 1;

    //Check if that last displayed page has a gap before the last page.
    this.showEndDots = this.pages[this.pages.length - 1].number + 1 < this.pageCount;
  }

  selectPage(selectedPage: number) {
    this.currentPage = selectedPage;
    this.#calculatePages(selectedPage);

    this.newPageSelected.emit(selectedPage);
  }

  onNextPage() {
    this.selectPage(this.currentPage + 1);
  }

  onPreviousPage() {
    this.selectPage(this.currentPage - 1);
  }
}
